module.exports = __webpack_public_path__ + "img/2025-08-16b_4.4eeb819b.jpg";